import { useEffect, useState, useRef } from 'react';

const useAvailableHeight = (offset) => {
    const [height, setHeight] = useState(window.innerHeight - offset);
    const containerRef = useRef(null);

    useEffect(() => {
        const adjustHeight = () => {
            const containerHeight = window.innerHeight - offset;
            setHeight(containerHeight);
        };

        adjustHeight();
        window.addEventListener('resize', adjustHeight);

        return () => {
            window.removeEventListener('resize', adjustHeight);
        };
    }, [offset]);

    return [height, containerRef];
};

export default useAvailableHeight;